export const CLIENT_VAL_OTP = "CLIENT_VAL_OTP";
export const CLIENT_VAL_OTP_ERROR = "CLIENT_VAL_OTP_ERROR";
export const CLIENT_VAL_OTP_HIDE_ERROR = "CLIENT_VAL_OTP_HIDE_ERROR";
export const CLIENT_VAL_OTP_START_LOADER = "CLIENT_VAL_OTP_START_LOADER";
export const CLIENT_VAL_OTP_STOP_LOADER = "CLIENT_VAL_OTP_STOP_LOADER";
export const LOGIN_SHOW_POPUP = "LOGIN_SHOW_POPUP";
